import { Dispatch, FC, SetStateAction } from 'react';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, Stack } from '@mui/material';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { modalActionBlockStyles } from '~/components/styles';
import { ImportDataStepsEnum } from './ImportDataModal';

interface ModalActionBlockProps {
  activeStep: ImportDataStepsEnum;
  setActiveStep: Dispatch<SetStateAction<ImportDataStepsEnum>>;
  onClose: () => void;
  onSubmit: () => void;
  submitDisabled: boolean;
}

const ModalActionBlock: FC<ModalActionBlockProps> = ({
  activeStep,
  onSubmit,
  onClose,
  submitDisabled,
  setActiveStep,
}) => {
  const datasetId = +useParams().id!;
  const { data } = useGetDatasetQuery({ datasetId });

  return (
    <Box sx={modalActionBlockStyles}>
      <CustomButton buttonType="borderless" label="Cancel" onClick={onClose} />
      <Stack direction="row" spacing={2}>
        {activeStep === ImportDataStepsEnum.DATA_IMPORT && data?.supportive_docs_upload_allowed && (
          <CustomButton
            buttonType="outlined"
            label="Back"
            onClick={() => setActiveStep(ImportDataStepsEnum.SUPPORTING_DOCUMENTS)}
          />
        )}
        <CustomButton onClick={onSubmit} disabled={submitDisabled}>
          {activeStep === ImportDataStepsEnum.SUPPORTING_DOCUMENTS ? 'Next' : 'Upload'}
        </CustomButton>
      </Stack>
    </Box>
  );
};

export default ModalActionBlock;
